
import { useState } from 'react';
import Navigation from '../../components/base/Navigation';
import { featuredPosters } from '../../mocks/posterData';

export default function Home() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filterWorks = (category: string) => {
    if (category === 'all') return featuredPosters;
    if (category === 'film') {
      return featuredPosters.filter(work => 
        work.category === 'WEB DRAMA'
      );
    }
    if (category === 'other') {
      return featuredPosters.filter(work => 
        ['TVC', 'MUSIC VIDEO', 'FASHION VIDEO'].includes(work.category)
      );
    }
    return featuredPosters;
  };

  const filteredWorks = filterWorks(activeFilter);

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16">
        <div className="max-w-6xl mx-auto px-6">
          {/* Hero Content */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-light tracking-wider mb-4">
              I'm DO BA DUC
            </h1>
            <h2 className="text-lg md:text-xl font-light tracking-widest text-gray-300 mb-12">
              Cinematography | Editor | Colorist from Ho Chi Minh City.
              <br />
              This is my personal website but the most important is what I can do.
              <br />
              Check out my works, I love to talk with you about our unique.
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
              FILM EDIT & COLORIST
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="flex items-center justify-center gap-4 mb-12">
            <button
              onClick={() => setActiveFilter('all')}
              className={`px-6 py-2 rounded-full text-sm font-light tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                activeFilter === 'all'
                  ? 'bg-white text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              All
            </button>
            <button
              onClick={() => setActiveFilter('film')}
              className={`px-6 py-2 rounded-full text-sm font-light tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                activeFilter === 'film'
                  ? 'bg-white text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              Film/Webdrama
            </button>
            <button
              onClick={() => setActiveFilter('other')}
              className={`px-6 py-2 rounded-full text-sm font-light tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
                activeFilter === 'other'
                  ? 'bg-white text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              Other
            </button>
          </div>
          
          {/* Featured Posters Grid - Filtered Results */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {filteredWorks.map((poster, index) => (
              <div key={poster.id || index} className="group cursor-pointer flex gap-4">
                <div className="w-24 flex-shrink-0">
                  <div className="aspect-[3/4] bg-gray-900 rounded-lg overflow-hidden">
                    <img
                      src={poster.src}
                      alt={poster.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
                <div className="flex-1 text-left flex flex-col justify-between">
                  <div>
                    <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">{poster.category}</p>
                    <h3 className="text-white text-sm font-light mb-2">{poster.title}</h3>
                  </div>
                  <div className="mt-auto">
                    <span className="text-gray-400 text-xs">{poster.director}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <footer className="py-8 border-t border-gray-800">
            <div className="max-w-6xl mx-auto px-6">
              <div className="flex items-center justify-center">
                <p className="text-gray-400 text-sm">
                  © Lenni Ken
                </p>
              </div>
            </div>
          </footer>
        </div>
      </section>
    </div>
  );
}
